// Auth0's Allowed Logout URLs for this SPA client only ever list the bare origin (see
// scripts/deploy/bootstrap.sh and each deployment's ops.tfvars auth0_spa_logout_urls) -- never a
// path. Auth0 validates `returnTo` against that allowlist including the path, so passing
// `${origin}/login?session=expired` as returnTo gets silently rejected and Auth0 falls back
// to its own default logout page instead of honoring the redirect. sessionStorage carries the
// "session expired" signal across the logout/re-login round trip instead, since the redirect
// itself must target an already-allowlisted bare origin.
const SESSION_EXPIRED_KEY = "murm_session_expired";

export function markSessionExpired() {
  sessionStorage.setItem(SESSION_EXPIRED_KEY, "1");
}

// Read-once: clears the flag immediately so it can't leak into an unrelated later visit to
// /login (e.g. after a normal user-initiated logout).
export function consumeSessionExpiredFlag() {
  const flagged = sessionStorage.getItem(SESSION_EXPIRED_KEY) === "1";
  if (flagged) sessionStorage.removeItem(SESSION_EXPIRED_KEY);
  return flagged;
}
